import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { BaseURL } from '../../config/apiUrl';
import { Get } from '../../Axios/AxiosFunctions';
import AddAutomatedSms from '../AddAutomatedSms';
import NotFound from '../NotFound';
import Loader from '../../Component/Loader';

const EditAutomatedSms = () => {
  const smsId = useParams()?.slug;

  const accessToken = useSelector((state) => state?.authReducer?.access_token);
  const baseApiUrl = BaseURL(`automated-sms-template`);
  const [isFound, setIsFound] = useState(true);
  const [isLoading, setIsLoading] = useState(true);

  const [data, setData] = useState(null);

  const getById = async () => {
    if (accessToken && accessToken?.length > 0) {
      const url = `${baseApiUrl}/${smsId}`;
      const response = await Get(url, accessToken);

      if (response?.status === 200) {
        setData(response?.data);
      } else {
        setIsFound(false);
      }

      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (smsId) {
      getById();
    }
  }, [smsId]);

  return (
    <div>
      {isLoading && <Loader />}
      {isFound && !isLoading && <AddAutomatedSms editData={data} />}
      {!isFound && !isLoading && <NotFound />}
    </div>
  );
};

export default EditAutomatedSms;
